import { ConstantType } from '../../../../helpers/types/_common';

export const ENGLISH_VALUE_BY_TYPE: ConstantType<number> = {
  ZERO: 0,
  GOOGLER: 1,
  WRITTEN_ONLY: 2,
  CONFIDENT: 3,
  LEVEL_80: 4,
};
